import { useEffect, useRef, useState, FC } from 'react'
import { createPortal } from 'react-dom'

const Portal: FC = ({ children }) => {
  let portalRef = useRef<Element | null>()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    portalRef.current = document.querySelector('#cgc-portal')
    if (portalRef.current) {
      setMounted(true)
    }
  }, [])

  return mounted ? createPortal(children, portalRef.current!) : null
}

export default Portal
